export enum ResponseStatus {
	SUCCESS = 'SUCCESS',
	ERRO = 'ERRO'
}

export interface SignUpResponse {
	status: string
	erro: string
}
